export default "__VITE_ASSET__6f452487__"